/**
 * Dates in a list are read as "how long ago", not as dates.
 *
 * `2026-08-01T09:12:00Z` → `12 minutes ago` / `Yesterday` / `24 Jul`. Anything older than a week
 * gets the calendar date, because "37 days ago" is arithmetic the reader has to undo.
 */
export function formatRelativeDate(iso: string): string {
  const then = new Date(iso).getTime();

  if (Number.isNaN(then)) {
    return '—';
  }

  const seconds = Math.round((Date.now() - then) / 1000);

  if (seconds < 60) {
    return 'Just now';
  }
  if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  }
  if (seconds < 86400) {
    const hours = Math.floor(seconds / 3600);
    return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  }
  if (seconds < 172800) {
    return 'Yesterday';
  }
  if (seconds < 604800) {
    return `${Math.floor(seconds / 86400)} days ago`;
  }

  const date = new Date(then);
  const sameYear = date.getFullYear() === new Date().getFullYear();

  return date.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    ...(sameYear ? {} : {year: 'numeric'}),
  });
}

/** Full timestamp for a `title` tooltip, so the exact time is still one hover away. */
export function formatExactDate(iso: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleString();
}
